import React, { useEffect, useState } from "react";
import "./MonitoringPage.css";
import { fetchEmployeeMonitoring } from "../../api/adminMonitoringApi";
import EmployeeRow from "./EmployeeRow";

const today = () => new Date().toISOString().split("T")[0];

const MonitoringPage = () => {
  const [date, setDate] = useState(today());
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadMonitoring = async () => {
    setLoading(true);
    try {
      const res = await fetchEmployeeMonitoring(date);
      setEmployees(res.data);
    } catch (e) {
      alert("Failed to load monitoring data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMonitoring();
  }, [date]);

  return (
    <div className="monitoring-page">
      <div className="monitoring-header">
        <h1>Monitoring</h1>

        <div className="monitoring-controls">
          <label>Date</label>
          <input
            type="date"
            value={date}
            onChange={e => setDate(e.target.value)}
          />
          <button onClick={loadMonitoring}>Refresh</button>
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : employees.length === 0 ? (
        <p>No data found</p>
      ) : (
        <div className="monitoring-tree">
          {employees.map(emp => (
            <EmployeeRow
              key={emp.employeeId}
              employee={emp}
              date={date}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MonitoringPage;
